const { HTMLElementExt } = await import(
    window._resolveImport?.("html-element-ext") || "html-element-ext"
);

const compare = await import(window._resolveImport?.("compare") || "compare");

const { load: loadComponent } = await import(
    window._resolveImport?.("deferred") || "deferred"
);

class CompareLink extends HTMLElementExt {
    constructor() {
        super();
        this.handles = {
            "compare-update::::body": this.update.bind(this),
        };
    }

    connectedCallback() {
        super.connectedCallback();
        this.update();
        compare.getItems().length && loadComponent("compareForm");
    }

    update() {
        const link = this.querySelector("a");
        const compareItems = compare.getItems();

        if (compareItems.length) link.dataset.count = compareItems.length;
        else delete link.dataset.count;
    }
}

export { CompareLink };
